import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from "recharts";
import DataTable from "../components/DataTable";

const dailyData = [
  { day: "Mon", downloads: 245 }, { day: "Tue", downloads: 312 }, { day: "Wed", downloads: 289 },
  { day: "Thu", downloads: 401 }, { day: "Fri", downloads: 378 }, { day: "Sat", downloads: 156 }, { day: "Sun", downloads: 189 },
];

const monthlyData = [
  { month: "Sep", downloads: 4230 }, { month: "Oct", downloads: 5120 }, { month: "Nov", downloads: 4890 },
  { month: "Dec", downloads: 5450 }, { month: "Jan", downloads: 6120 }, { month: "Feb", downloads: 5890 },
  { month: "Mar", downloads: 2450 },
];

const userData = [
  { id: "u1", user: "John Smith",    client: "Acme Corporation",     downloads: 245, lastLogin: "2026-03-06 09:30", lastDownload: "2026-03-06 11:45" },
  { id: "u2", user: "Sarah Johnson", client: "Global Tech Solutions", downloads: 198, lastLogin: "2026-03-06 08:15", lastDownload: "2026-03-06 10:20" },
  { id: "u3", user: "Michael Brown", client: "Enterprise Dynamics",   downloads: 167, lastLogin: "2026-03-05 16:45", lastDownload: "2026-03-06 09:15" },
  { id: "u4", user: "Emily Davis",   client: "Innovation Partners",   downloads: 142, lastLogin: "2026-03-05 14:20", lastDownload: "2026-03-05 17:30" },
  { id: "u5", user: "David Wilson",  client: "Strategic Ventures",    downloads: 128, lastLogin: "2026-03-05 11:00", lastDownload: "2026-03-05 15:20" },
];

const columns = [
  { key: "user",         label: "User Name",            sortable: true },
  { key: "client",       label: "Client",               sortable: true },
  { key: "downloads",    label: "Invoices Downloaded",  sortable: true },
  { key: "lastLogin",    label: "Last Login",           sortable: true },
  { key: "lastDownload", label: "Last Download",        sortable: true },
];

export default function ActivityMonitoringPage() {
  return (
    <div className="p-8">
      <div className="mb-8">
        <h1 className="text-3xl font-semibold text-gray-900">Activity Monitoring</h1>
        <p className="text-gray-500 mt-1">Track user activity and download statistics</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-6">Daily Downloads</h2>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={dailyData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="day"   stroke="#9ca3af" fontSize={12} />
              <YAxis               stroke="#9ca3af" fontSize={12} />
              <Tooltip />
              <Bar dataKey="downloads" fill="#367588" radius={[4,4,0,0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-6">Monthly Downloads</h2>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={monthlyData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="month" stroke="#9ca3af" fontSize={12} />
              <YAxis               stroke="#9ca3af" fontSize={12} />
              <Tooltip />
              <Line type="monotone" dataKey="downloads" stroke="#367588" strokeWidth={2} dot={{ fill: "#367588", strokeWidth: 2, r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div>
        <h2 className="text-xl font-semibold text-gray-900 mb-4">User Activity</h2>
        <DataTable columns={columns} data={userData} />
      </div>
    </div>
  );
}
